import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Mail } from "lucide-react";

export default function PressInquiriesCard() {
  const [inquiries, setInquiries] = useState([]);

  useEffect(() => {
    api.get("/admin/press-inquiries").then((r) => setInquiries(r.data || []));
  }, []);

  return (
    <div className="tac-card p-7 mt-8" data-testid="press-inquiries-card">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="overline flex items-center gap-2">
            <Mail size={12} /> Brand &amp; press inquiries
          </div>
          <h2 className="font-display text-3xl uppercase mt-2">Inbox</h2>
        </div>
        <div className="font-mono-tactical text-xs text-white/50 uppercase tracking-[0.25em]">
          {inquiries.length} total
        </div>
      </div>
      <div className="mt-6 divide-y divide-white/5">
        {inquiries.length === 0 && (
          <div className="py-8 text-white/60 text-sm">
            No inquiries yet. Brand partners will land here when they hit /press.
          </div>
        )}
        {inquiries.map((q) => (
          <div key={q.id} className="py-4 grid md:grid-cols-12 gap-3" data-testid={`inquiry-${q.id}`}>
            <div className="md:col-span-3">
              <div className="font-display text-lg uppercase">{q.name}</div>
              <a
                href={`mailto:${q.email}`}
                className="text-xs font-mono-tactical text-[#FF1493] hover:underline"
              >
                {q.email}
              </a>
              {q.company && (
                <div className="text-xs text-white/50 mt-1">{q.company}</div>
              )}
            </div>
            <div className="md:col-span-2">
              <span className="bg-[#0A0A0A] border border-[#FFC107]/40 text-[#FFC107] px-2 py-1 text-[10px] tracking-[0.2em] uppercase font-display">
                {q.inquiry_type}
              </span>
              <div className="text-[10px] font-mono-tactical text-white/40 mt-2 uppercase tracking-[0.2em]">
                {new Date(q.created_at).toLocaleDateString()}
              </div>
            </div>
            <div className="md:col-span-7 text-sm text-white/80 whitespace-pre-wrap">
              {q.message}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
